'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activator = function () {
    function Activator() {
        (0, _classCallCheck3.default)(this, Activator);

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
    }

    /**
     * 插件入口
     * 
     * @param {PluginContext} context 插件上下文
     * @memberof Activator
     */

    /**
     * 插件上下文缓存
     * 
     * @type {PluginContext}
     * @static
     * @memberof Activator
     */


    (0, _createClass3.default)(Activator, [{
        key: 'start',
        value: function start(context) {
            Activator.context = context;
        }

        /**
         * 插件出口
         * 
         * @param {PluginContext} context 插件上下文
         * @memberof Activator
         */

    }, {
        key: 'stop',
        value: function stop(context) {
            Activator.context = null;
        }
    }]);
    return Activator;
}();

Activator.context = null;
exports.default = Activator;
//# sourceMappingURL=Activator.js.map